import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { API } from "../App";

export const ForcePasswordChange = ({ user, onDone, logout }) => {
  const [pwd, setPwd] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pwd !== confirm) { toast.error("Les deux mots de passe ne correspondent pas"); return; }
    setBusy(true);
    try {
      await axios.post(`${API}/auth/set-password`, { new_password: pwd }, { withCredentials: true });
      toast.success("Nouveau mot de passe enregistré");
      onDone();
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Mot de passe invalide");
    } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6" data-testid="force-password-change">
      <form onSubmit={submit} className="w-full max-w-md space-y-4 rounded-2xl border bg-card p-6 shadow-sm">
        <div className="flex items-center gap-2"><KeyRound className="w-6 h-6 text-primary" /><h1 className="font-heading text-xl font-bold">Choisissez un nouveau mot de passe</h1></div>
        <p className="text-sm text-muted-foreground">Bonjour {user?.name?.split(" ")[0]}, vous vous êtes connecté(e) avec un mot de passe provisoire. Pour sécuriser votre espace, définissez maintenant votre propre mot de passe (8 caractères minimum, avec majuscule, minuscule et chiffre).</p>
        <div className="space-y-1.5"><Label htmlFor="new-pwd">Nouveau mot de passe</Label><Input id="new-pwd" type="password" value={pwd} onChange={(e) => setPwd(e.target.value)} autoComplete="new-password" required data-testid="force-pwd-new" /></div>
        <div className="space-y-1.5"><Label htmlFor="confirm-pwd">Confirmer</Label><Input id="confirm-pwd" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} autoComplete="new-password" required data-testid="force-pwd-confirm" /></div>
        <Button type="submit" className="w-full gap-2" disabled={busy || pwd.length < 8} data-testid="force-pwd-submit">{busy && <Loader2 className="w-4 h-4 animate-spin" />} Enregistrer et continuer</Button>
        <button type="button" onClick={logout} className="w-full text-xs text-muted-foreground hover:underline">Se déconnecter</button>
      </form>
    </div>
  );
};
